import styled from 'styled-components';
import { PortalLink } from 'src/components/Buttons';

export const Link = styled(PortalLink)`
  display: block;
`;
